
class TaxRegimeTypeCell extends UITableViewCell
{
    private titleTextField:MUITextField = null;
    private valueTextField:MUITextField = null;

    private _item:TaxRegimeType = null;

    awakeFromHTML(){
        this.titleTextField = MUIOutlet(this, "title-tf", "MUITextField");
        if (this.titleTextField) this.titleTextField.setOnChangeText(this, function(this:TaxRegimeTypeCell, control:MUITextField, value:string){
            if (this._item != null) this._item.title = value;
        });

        this.valueTextField = MUIOutlet(this, "value-tf", "MUITextField");
        if (this.valueTextField) this.valueTextField.setOnChangeText(this, function(this:TaxRegimeTypeCell, control:MUITextField, value:string){
            if (this._item != null) {
                let v = parseInt(value);
                this._item.value = isNaN(v) ? 0 : v;
            }
        });

        this.selectionStyle = UITableViewCellSelectionStyle.None;
    }

    set item(item:TaxRegimeType){
        this._item = item;
        this.titleTextField.text = item.title;
        this.valueTextField.text = item.value != null ? item.value.toString() : "";
    }
}
